// src/auth/screens/NoAccessScreen.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext.jsx';

export default function NoAccessScreen() {
  const { logout, isSuperadmin } = useAuth();
  const navigate = useNavigate();

  if (isSuperadmin) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0e0e18', fontFamily: "'DM Sans', sans-serif" }}>
        <div style={{ textAlign: 'center', maxWidth: '360px', padding: '0 24px' }}>
          <p style={{ fontSize: '32px', marginBottom: '16px' }}>🛡️</p>
          <h2 style={{ color: '#e4e4ec', fontSize: '20px', fontWeight: 700, marginBottom: '8px' }}>Modalità superadmin</h2>
          <p style={{ color: '#7a7a8e', fontSize: '14px', marginBottom: '28px' }}>Accedi alla console di amministrazione per gestire utenti e tenant.</p>
          <button
            onClick={() => navigate('/admin/users', { replace: true })}
            style={{ padding: '10px 24px', borderRadius: '8px', border: 'none', background: '#E8002D', color: '#fff', fontSize: '14px', fontWeight: 600, cursor: 'pointer' }}
          >
            Vai alla console admin
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0e0e18', fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ textAlign: 'center', maxWidth: '360px', padding: '0 24px' }}>
        <p style={{ fontSize: '32px', marginBottom: '16px' }}>🔒</p>
        <h2 style={{ color: '#e4e4ec', fontSize: '20px', fontWeight: 700, marginBottom: '8px' }}>Nessun tenant assegnato</h2>
        <p style={{ color: '#7a7a8e', fontSize: '14px', marginBottom: '28px' }}>Contatta il tuo amministratore per ottenere l'accesso.</p>
        <button onClick={logout} style={{ padding: '10px 24px', borderRadius: '8px', border: 'none', background: '#E8002D', color: '#fff', fontSize: '14px', fontWeight: 600, cursor: 'pointer' }}>
          Torna al login
        </button>
      </div>
    </div>
  );
}
